import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './footer.css';

export default function Footer() {
    const { t } = useTranslation();
    const year = new Date().getFullYear()
    return (
        <footer>
            <div className="footer__wrapper">
                <div className="footer__info">
                    <div className="footer_name">{year} © Rusty Life</div>
                </div>
                <Link to="/tos" className="footer_tos" title={t('main.header.toTheMain')}>
                    {t('tos.title')}
                </Link>
            </div>
        </footer>
    )
}